export default __webpack_public_path__ + "static/media/issuer-facebook.1eb45007.svg";